export type PreviewTextMetrics = {
  ascent: number
  descent: number
  height: number
}

let previewTextMeasureCanvas: HTMLCanvasElement | null = null

function getPreviewTextMeasureContext(): CanvasRenderingContext2D {
  if (!previewTextMeasureCanvas) {
    previewTextMeasureCanvas = document.createElement('canvas')
  }
  const ctx = previewTextMeasureCanvas.getContext('2d')
  if (!ctx) {
    throw new Error('preview text measure context create failed')
  }
  return ctx
}

export function measurePreviewText(
  ctx: CanvasRenderingContext2D,
  text: string,
  fallbackFontSize: number,
): PreviewTextMetrics {
  const metrics = ctx.measureText(text || 'Ag')
  const fallbackAscent = Math.max(1, Math.round(fallbackFontSize * 0.78))
  const fallbackDescent = Math.max(1, Math.round(fallbackFontSize * 0.22))
  const ascent = Math.max(1, Math.round(metrics.actualBoundingBoxAscent || fallbackAscent))
  const descent = Math.max(1, Math.round(metrics.actualBoundingBoxDescent || fallbackDescent))
  return {
    ascent,
    descent,
    height: ascent + descent,
  }
}

export function measurePreviewTextWithFont(
  text: string,
  fontSize: number,
  fontFamily: string,
): PreviewTextMetrics {
  const ctx = getPreviewTextMeasureContext()
  ctx.font = `${Math.max(10, Math.round(fontSize))}px ${fontFamily}`
  return measurePreviewText(ctx, text, fontSize)
}

export function getPreviewTextTop(
  boxHeight: number,
  metrics: PreviewTextMetrics,
  verticalAlign: 'top' | 'center',
): number {
  if (verticalAlign !== 'center') {
    return 0
  }
  return Math.max(0, Math.round((boxHeight - metrics.height) / 2))
}

export function getPreviewCenterOffset(containerSize: number, contentSize: number): number {
  return Math.trunc((containerSize - contentSize) / 2)
}

export function getPreviewTextBaselineY(
  boxHeight: number,
  metrics: PreviewTextMetrics,
  verticalAlign: 'top' | 'center',
): number {
  return getPreviewTextTop(boxHeight, metrics, verticalAlign) + metrics.ascent
}

